module.exports = __webpack_public_path__ + "img/lineBtn.642372a9.svg";